<template>
    <div class="wrap wrap--products">
        <main-header></main-header>

        <main class="main" role="main">
            <div class="interior-list-container" data-filter="opened">
                <!-- 주거형태/공간 -->
                <nav class="interior-theme">
                    <span class="interior-theme__band"></span>
                    <div class="interior-theme__wrap">
                        <div class="interior-theme__inner">
                            <!-- 포트폴리오 테마 -->
                            <portfolio-theme v-model="filter._category" :items="category.children" item-text="name" item-value="_id" default-value="5fae46e6dc19c41f74a85f04" @input="page = 1; search()"></portfolio-theme>
                        </div>
                    </div>
                </nav>
                <!-- 좌측 필터 -->
                <div class="interior-fillters">
                    <div class="interior-fillters__inner">
                        <div class="filter-sidebar-container" data-filter-fixed="off">
                            <button class="toggle" aria-pressed="true"><span class="blind">필터 사이드바 토글</span></button>
                            <portfolio-filter v-model="filter" @input="page = 1; search()"></portfolio-filter>
                            <div class="filter-sidebar-dimmed"></div>
                        </div>
                    </div>
                </div>
                <!-- 포트폴리오 -->
                <section class="interior-lists">
                    <div class="interior-lists__inner">
                        <div class="interior-lists__head">
                            <!-- 리스트페이지 검색/제어 바 -->
                            <div class="listing-result">
                                <div class="listing-result__total">
                                    <span>총 <em>{{ totalCount }}</em> 개 인테리어</span>
                                </div>
                                <div class="listing-result__select">
                                    <select class="listing-result__select-option" v-model="sort" @input="search(false)">
                                        <option value="byLatest">최근순</option>
                                        <option value="byViews">조회수순</option>
                                        <option value="byLikes">좋아요순</option>
                                        <option value="byBookmarks">스크랩순</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="interior-lists__body">
                            <div class="grid">
                                <div v-for="portfolio in portfolios" :key="portfolio._id" class="grid-8">
                                    <!-- 포트폴리오 리스팅 -->
                                    <portfolio-item :value="portfolio"></portfolio-item>
                                </div>
                            </div>
                        </div>
                        <!-- 포트폴리오 페이징 -->
                        <div class="interior-lists__pagination">
                            <pagination-component :value="page" :count="pageCount" @change="search()"></pagination-component>
                        </div>
                    </div>
                </section>
            </div>
        </main>

        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import PaginationComponent from "@/components/client/control/pagination-component.vue";

import PortfolioTheme from "@/components/client/portfolio/portfolio-theme.vue";
import PortfolioFilter from "@/components/client/portfolio/portfolio-filter.vue";
import PortfolioItem from "@/components/client/portfolio/portfolio-item.vue";

export default {
    components : {
        MainHeader,
        MainFooter,

        PaginationComponent,

        PortfolioTheme,
        PortfolioFilter,
        PortfolioItem
    },
    data(){
        return {
            loading : false,

            filter: {
                _category: this.$route.query._category || "5fae46e6dc19c41f74a85f04",
            },

            category: { children: [] },

            sort: "byLatest",

            page : 1,
            pageCount : 0,
            limit : 12,

            totalCount : 0,
            portfolios : []
        }
    },
    async mounted() {
        await this.init();
        this.initPublisher();
    },
    methods: {
        async init() {
            try {
                var { category } = await api.v1.portfolios.categories.getCategory({ _id: this.filter._category });
                this.category = category;

                await this.search(false);

            }catch(error) {
                console.error(error);
            }
        },

        async search(routable = true) {
            try {
                if(routable){
                    this.$router.push({
                        query: Object.assign({}, this.filter, { page: this.page })
                    });
                }

                var { summary, portfolios } = await api.v1.portfolios.getPortfolios({
                    headers : {
                        skip: (this.page - 1 ) * this.limit,
                        limit: this.limit,
                        sort: this.sort
                    },
                    params: this.filter
                });

                this.portfolios = portfolios;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
                this.totalCount = summary.totalCount;

                this.loading = true;

            }catch(error) {
                console.error(error);
            }
        },

        initPublisher : function(){
            this.$nextTick(function () {
                const HTML = document.querySelector('html'),
                      container = document.querySelector('.interior-list-container'),
                      toggle = document.querySelector('.interior-list-container .toggle'),
                      buttons = document.querySelectorAll('.filter-sidebar .bottom-button .button');
                toggle.addEventListener('click', function(){
                    let state = this.getAttribute('aria-pressed');
                    if(state === 'true'){
                        HTML.removeAttribute('data-scroll');
                        this.setAttribute('aria-pressed', 'false');
                        container.setAttribute('data-filter', 'closed');
                    }else{
                        if(window.innerWidth < 1280){
                            HTML.setAttribute('data-scroll', 'false');
                        }
                        this.setAttribute('aria-pressed', 'true');
                        container.setAttribute('data-filter', 'opened');
                    }
                });

                // Sticky filter
                let scroll_pos = 0,
                    ticking = false;

                let parentElement = document.querySelector('.interior-fillters'),
                    stickyElement = document.querySelector('.filter-sidebar-container'),
                    header = document.querySelector('.header'),
                    headerHeight = 0,
                    absoluteTop = 0,
                    length = 0,
                    height = stickyElement.offsetHeight;

                function doSomething() {
                    if(window.innerWidth > 1024){
                        headerHeight = header.clientHeight;
                        scroll_pos = window.scrollY || window.pageYOffset;
                        absoluteTop = window.pageYOffset + parentElement.getBoundingClientRect().top;
                        length = parentElement.offsetHeight - stickyElement.offsetHeight + absoluteTop;

                        if(scroll_pos < absoluteTop - headerHeight){
                            stickyElement.style.position = 'absolute';
                            stickyElement.style.top = '0';
                            stickyElement.style.bottom = 'auto';
                        }else if(scroll_pos > length - headerHeight){
                            stickyElement.style.position = 'absolute';
                            stickyElement.style.top = 'auto';
                            stickyElement.style.bottom = '0';
                        }else{
                            stickyElement.style.position = 'fixed';
                            stickyElement.style.top = headerHeight + 'px';
                            stickyElement.style.bottom = 'auto';
                        }
                        HTML.removeAttribute('data-scroll');
                    }else{
                        buttons.forEach(function(element){
                            element.addEventListener('click', function(){
                                HTML.removeAttribute('data-scroll');
                                toggle.setAttribute('aria-pressed', 'false');
                                container.setAttribute('data-filter', 'closed');
                            });
                        })
                    }

                    if(window.innerWidth < 1280){
                        toggle.setAttribute('aria-pressed', 'false');
                        container.setAttribute('data-filter', 'closed');
                    }
                }

                doSomething();

                window.addEventListener('scroll', function(e) {
                    if (!ticking) {
                        window.requestAnimationFrame(function() {
                            doSomething();
                            ticking = false;
                        });
                        ticking = true;
                    }
                });

                window.addEventListener("resize", resize, false);
                let mobileWidth = 1024;
                let timeout;

                function resize() {
                    if ( !timeout ) {
                        timeout = setTimeout(function() {
                            timeout = null;
                            handle();
                        }, 66);
                    }
                }
                function handle() {
                    let windowWidth = window.outerWidth;
                    if(windowWidth > mobileWidth){
                        doSomething();
                    }
                }
            })
        },
    }
}
</script>

<style lang="css" scoped>
</style>
